var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-wrap"},[_c('ul',{ref:"childTabSet",staticClass:"child-tab",class:[_vm.childTabIsFixed? 'isFixed':'']},_vm._l((_vm.childrenTabData),function(v,i){return _c('li',{key:i,class:[_vm.currentIndex===i? 'active':''],on:{"click":function($event){return _vm.scrollTo(i)}}},[_vm._v(_vm._s(v))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }